module.exports = __webpack_public_path__ + "static/img/moment7.f35993e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/school/moment7.png
// module id = +9SP
// module chunks = 1